export class ClosingPortalApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoans() {
    return this.#http.get('/api/closing-portal/loans');
  }

  async getLoanSummary({ applicationId }) {
    return this.#http.get(`/api/closing-portal/loans/${encodeURIComponent(applicationId)}/summary`);
  }

  async getWireInstructions({ loanId }) {
    return this.#http.get(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/wire-instructions`,
    );
  }

  async confirmWireInstructions({ loanId }) {
    return this.#http.post(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/wire-instructions/confirm`,
    );
  }

  async rejectWireInstructions({ loanId, reason }) {
    return this.#http.post(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/wire-instructions/reject`,
      {
        reason,
      },
    );
  }

  async getFees({ loanId }) {
    return this.#http.get(`/api/closing-portal/loans/${encodeURIComponent(loanId)}/fees`);
  }

  async getFeeTypes({ loanId }) {
    return this.#http.get(`/api/closing-portal/loans/${encodeURIComponent(loanId)}/fee-types`);
  }

  async getFeeRecommendations({ loanId }) {
    return this.#http.get(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/fee-recommendations`,
    );
  }

  async submitFeeRecommendations({ loanId, items, draftSessionId = null }) {
    return this.#http.post(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/fee-recommendations`,
      {
        items,
        draftSessionId,
      },
    );
  }

  async getDocuments({ loanId }) {
    return this.#http.get(`/api/closing-portal/loans/${encodeURIComponent(loanId)}/documents`);
  }

  async uploadDocument({ loanId, kind, file }) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('kind', kind);

    return this.#http.post(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/documents`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  }

  async getDocumentContent({ loanId, documentId }) {
    return this.#http.get(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/documents/${encodeURIComponent(documentId)}/content`,
      { responseType: 'blob' },
    );
  }

  async getDraftFeeRecommendations({ loanId }) {
    return this.#http.get(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/fee-recommendations/draft`,
    );
  }

  async discardDraftFeeRecommendations({ loanId, sessionId }) {
    return this.#http.post(
      `/api/closing-portal/loans/${encodeURIComponent(loanId)}/fee-recommendations/drafts/${encodeURIComponent(sessionId)}/discard`,
    );
  }
}
